import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      console.log('Form submitted:', formData);
      alert('Thank you for your message! We will contact you soon.');
      setIsSubmitting(false);
      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        message: ''
      });
    }, 1000);
  };

  const isFormValid = () => {
    return formData.firstName && formData.lastName && formData.email && formData.message;
  };

  return (
    <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
      {/* Breadcrumb Navigation */}
      <div style={{ 
        maxWidth: '1400px', 
        margin: '0 auto', 
        padding: '1rem 2rem 0 2rem',
        backgroundColor: 'white'
      }}>
        <nav className="contact-breadcrumb">
          <a href="/" className="breadcrumb-link">Home</a>
          <span className="breadcrumb-separator"> › </span>
          <span className="breadcrumb-current">Contact Us</span>
        </nav>
      </div>

      <div className="contact-page-container">
        {/* Contact Header */}
        <div className="contact-header-section">
          <h1 className="contact-main-title">Contact Us</h1>
          <p className="contact-subtitle">Get in touch with our team for support, quotes, or general inquiries</p>
        </div>

        <div className="contact-content">
          {/* Contact Form */}
          <div className="contact-form-section">
            <div className="contact-form-card">
              <h2 className="form-title">Send us a Message</h2>
              <p className="form-description">Fill out the form below and we'll get back to you as soon as possible.</p>
              
              <div className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName" className="form-label">
                      First Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      value={formData.firstName}
                      onChange={(e) => handleInputChange('firstName', e.target.value)}
                      className="form-input"
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="lastName" className="form-label">
                      Last Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      value={formData.lastName}
                      onChange={(e) => handleInputChange('lastName', e.target.value)}
                      className="form-input"
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Email Address <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="form-label">
                    Message <span className="required">*</span>
                  </label>
                  <textarea
                    id="message"
                    value={formData.message}
                    onChange={(e) => handleInputChange('message', e.target.value)}
                    className="form-textarea"
                    rows="6"
                    placeholder="Please describe your inquiry or question..."
                    required
                  ></textarea>
                </div>

                <button 
                  onClick={handleSubmit}
                  className="submit-btn"
                  disabled={!isFormValid() || isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .contact-page-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 2rem;
          background: white;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        /* Breadcrumb Navigation */
        .contact-breadcrumb {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.9rem;
          margin-bottom: 2rem;
        }

        .breadcrumb-link {
          color: #6b7280;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s ease;
        }

        .breadcrumb-link:hover {
          color: #09244f;
          text-decoration: underline;
        }

        .breadcrumb-current {
          color: #09244f;
          font-weight: 600;
        }

        .breadcrumb-separator {
          color: #d1d5db;
        }

        /* Header */
        .contact-header-section {
          text-align: center;
          margin-bottom: 3rem;
          padding-bottom: 2rem;
          border-bottom: 1px solid #e5e7eb;
        }

        .contact-main-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #111827;
          margin: 0 0 1rem 0;
        }

        .contact-subtitle {
          font-size: 1.1rem;
          color: #6b7280;
          margin: 0;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
          line-height: 1.6;
        }

        /* Content Layout */
        .contact-content {
          gap: 3rem;
          align-items: center;
        }

        /* Form Section */
        .contact-form-section {
          background: white;
        }

        .contact-form-card {
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 2rem;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }

        .form-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: #111827;
          margin: 0 0 0.5rem 0;
        }

        .form-description {
          color: #6b7280;
          margin-bottom: 2rem;
          line-height: 1.5;
        }

        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-label {
          font-weight: 600;
          color: #374151;
          margin-bottom: 0.5rem;
          font-size: 0.9rem;
        }

        .required {
          color: #dc2626;
          font-weight: 700;
        }

        .form-input, .form-textarea {
          padding: 1rem;
          border: 2px solid #e5e7eb;
          border-radius: 8px;
          font-size: 1rem;
          transition: all 0.2s ease;
          font-family: inherit;
        }

        .form-input:focus, .form-textarea:focus {
          outline: none;
          border-color: #09244f;
          box-shadow: 0 0 0 3px rgba(9, 36, 79, 0.1);
        }

        .form-textarea {
          resize: vertical;
          min-height: 120px;
        }

        .submit-btn {
          background: #09244f;
          color: white;
          border: none;
          padding: 1rem 2rem;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          margin-top: 1rem;
        }

        .submit-btn:hover:not(:disabled) {
          background: #061a3d;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(9, 36, 79, 0.3);
        }

        .submit-btn:disabled {
          background: #9ca3af;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        /* Contact Info Section */
        .contact-info-section {
          display: flex;
          flex-direction: column;
          gap: 2rem;
        }

        .contact-info-card, .quick-links-card {
          background: #f1f5f9;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 2rem;
        }

        .info-title, .quick-links-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #09244f;
          margin: 0 0 0.5rem 0;
        }

        .info-description {
          color: #6b7280;
          margin-bottom: 2rem;
          line-height: 1.5;
        }

        .contact-methods {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .contact-method {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          padding: 1rem;
          background: white;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
        }

        .method-icon {
          font-size: 2rem;
          width: 3rem;
          height: 3rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .method-icon.phone {
          background: #dbeafe;
        }

        .method-icon.email {
          background: #dcfce7;
        }

        .method-icon.emergency {
          background: #fef2f2;
        }

        .method-details h3 {
          font-weight: 600;
          color: #111827;
          margin: 0 0 0.25rem 0;
          font-size: 1rem;
        }

        .method-details p {
          color: #09244f;
          font-weight: 500;
          margin: 0 0 0.25rem 0;
        }

        .method-hours {
          color: #6b7280;
          font-size: 0.875rem;
        }

        /* Quick Links */
        .quick-links-grid {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .quick-link {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          background: white;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          text-decoration: none;
          color: inherit;
          transition: all 0.2s ease;
        }

        .quick-link:hover {
          border-color: #09244f;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .link-icon {
          font-size: 1.5rem;
          width: 2.5rem;
          height: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f3f4f6;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .quick-link strong {
          color: #111827;
          font-weight: 600;
          margin-bottom: 0.25rem;
          display: block;
        }

        .quick-link p {
          color: #6b7280;
          font-size: 0.875rem;
          margin: 0;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .contact-content {
            grid-template-columns: 1fr;
            gap: 2rem;
          }
        }

        @media (max-width: 768px) {
          .contact-page-container {
            padding: 1rem;
          }

          .contact-main-title {
            font-size: 2rem;
          }

          .contact-form-card, .contact-info-card, .quick-links-card {
            padding: 1.5rem;
          }

          .form-row {
            grid-template-columns: 1fr;
          }

          .contact-method {
            flex-direction: column;
            text-align: center;
          }
        }

        @media (max-width: 480px) {
          .contact-main-title {
            font-size: 1.75rem;
          }

          .contact-form-card, .contact-info-card, .quick-links-card {
            padding: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Contact;